import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ProjectService } from '../../../../services/project.service';
import { UiService } from '../../../../services/core.ui.service';
import { GfTranslateService } from '../../../../services/core.translate.service';

import * as _ from 'lodash';
import { HttpClient } from '@angular/common/http';
import { doGetPromise } from '../../../../config/core.httpclient-utils';

@Component({
    selector: 'project-team-addmember',
    template: require('./project.team.addmember.component.html'),
})
export class ProjectTeamAddMemberComponent {

    @Input() roleList: any = null;
    @Input() project: any = null;
    @Output() onUpdate = new EventEmitter<void>();

    protected open: boolean = true;
    protected filter: string = '';
    protected selectedRoles: Array<any> = [];
    protected items: any = null;
    protected searching: boolean = false;
    protected rolesLabel: string|false = "";

    constructor(
        private projectService: ProjectService,
        private uiService: UiService,
        private gfTranslateService: GfTranslateService,
        private http: HttpClient,
    ) { }

    protected hasRole(role: any): boolean {
        return this.selectedRoles.find((r) => r.id === role.id) !== undefined;
    }

    protected toggleRole(role: any): void {
        if (this.hasRole(role)) {
            this.selectedRoles = this.selectedRoles.filter((item) => item !== role);
        } else {
            this.selectedRoles = this.selectedRoles.concat(role);
        }
        this.rolesLabel = this.getRolesLabel();
    }

    private getRolesLabel(): string | false {
        const len = _.get(this.selectedRoles, 'length', 0);
        if (len === 0) {
            return false;
        }
        if (len < 4) {
            return this.selectedRoles.map((item) => item.roleName).join(',');
        }
        return `${this.selectedRoles.length} roles`;
    }

    private addUser(user: any): void {
        this.addUserToRoles(user.refId, this.selectedRoles, this.rolesLabel, user.description);
    }

    protected addUserToRoles(user, roles, rolesDescription, userFullName) {
        const _roles = (_.map(roles, (role) => { return role.id })).join(',');
        const userId = user.refId;

        this.projectService.addMember(
            this.project.unixName,
            userId,
            { roles: _roles })
            .then(
                () => {
                    var msg = this.gfTranslateService.translate('{{userName}} has been added to the project ({{roleName}})',
                        { 'userName': userFullName || userId, 'roleName': rolesDescription || roles.length + ' role(s)' });
                    this.uiService.message.showSuccess(msg, 'Add Members');
                    this.resetMemberAdd();
                    this.onUpdate.emit();
                },
                (error: any) => {
                    if (error.status === 403) {
                    var msg = this.gfTranslateService.translate('Invalid request when trying to add {{unixName}} to the project',
                        { 'unixName': userFullName || userId });
                    this.uiService.message.showWarning(msg, 'Add Members');
                    } else if (error.status === 400) {
                    var msg = this.gfTranslateService.translate('{{unixName}} already has all the selected roles in this project',
                        { 'unixName': userId });
                    this.uiService.message.showWarning(msg, 'Add Members');
                    } else {
                    // Other errors
                    var msg = this.gfTranslateService.translate('There was a problem adding {{unixName}} to the project',
                        { 'unixName': userFullName || userId });
                    this.uiService.message.showWarning(msg, 'Add Members');
                    }
                }
            );
    }

    private resetMemberAdd() {
        this.items = false;
        this.filter = '';
        this.selectedRoles = [];
    }

    protected searchUsers() {
        this.items = false;

        if (_.get(this, 'filter', '') == '') {
            return false;
        }

        this.searching = true;

        var params = {
            q: this.filter,
            s: 'user,group',
            p: this.project.unixName,
            l: 0,
            page_num: 1,
            page_size: 5
        };

        doGetPromise(this.http, '/api/search/', params)
        .then((response) => {
            this.items = _.sortBy(
                _.get(response, 'items', []),
                ['matchScore', 'title']
            ).reverse();
        }).catch(function () {
            this.uiService.message.showWarning('Sorry, could not search for users', 'Search Failed');
            this.items = false;
        }).finally( () => {
            this.searching = false;
        });
    }    
}
